export enum OrdersStorageKey {
  ADD_ORDER_FORM = 'addOrderForm',
}
